import { Component, OnInit, OnDestroy, ChangeDetectorRef, Inject, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { CognitoService } from '../../services/cognito.service';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogContent,
    MatButtonModule,
    CommonModule,
    ReactiveFormsModule,
    NgxMaskDirective
  ],
  styleUrls: ['./logout-modal.component.scss'],
  providers: [
    provideNgxMask(),
  ],
})
export class LogoutModalComponent implements OnInit, OnDestroy {
  timeout: number = 60; // in seconds
  interval: any;
  remainingTime: number = this.timeout; // Keep track of remaining time

  generatedCode:string = ''
  inputs: string[] = ['', '', '', ''];
  numericForm: FormGroup;
  codeError:boolean = false

  @ViewChildren('inputField') inputFields!: QueryList<ElementRef>;

  private worker: Worker | null = null;

  constructor(
      private fb: FormBuilder,
      private dialogRef: MatDialogRef<LogoutModalComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { timeout: number },
      private cognitoService: CognitoService,
      private authService: AuthService,
      private _cdr : ChangeDetectorRef
    ) {
      this.timeout = this.data.timeout
      this.numericForm = this.fb.group({
        input1: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
        input2: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
        input3: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
        input4: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      });

      this.numericForm.statusChanges.subscribe((status) => {
        if (status === 'VALID') {
          this.onCodeComplete();
        }
      });
  }

  ngOnInit() {
    this.generatedCode = this.generateRandomCode()
    this.start();
  }

  ngAfterViewInit() {
    const firstInput = this.inputFields?.first;
    if (firstInput) {
      firstInput.nativeElement.focus();
    }
  }

  onCodeComplete() {
    const inputs = [
      this.numericForm.get('input1')?.value,
      this.numericForm.get('input2')?.value,
      this.numericForm.get('input3')?.value,
      this.numericForm.get('input4')?.value,
    ];

    const code = inputs.join('');

    if(code === this.generatedCode){
      this.authService.refreshToken()
      this.dialogRef.close()
    }else{
      this.codeError = true
    }
  }

  start() {
    if (!this.worker) {
      this.worker = new Worker(new URL('./timer.worker', import.meta.url));
      this.worker.postMessage({ duration: this.remainingTime });

      this.worker.onmessage = (event) => {
        const { remainingTime, done } = event.data;
        if (done) {
          this.logout();
        } else {
          this.remainingTime = remainingTime;
        }
      };
    }
  }

  logout() {
    this.terminateWorker();
    this.dialogRef.close()
    this.cognitoService.signOut(true)
  }

  private terminateWorker() {
    if (this.worker) {
      this.worker.terminate();
      this.worker = null; // Limpiar la referencia para evitar fugas de memoria
    }
  }

  generateRandomCode(): string {
    const min = 1000; // Mínimo número de 4 dígitos
    const max = 9999; // Máximo número de 4 dígitos
    const randomCode = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomCode.toString();
  }

  moveToNext(event: any, index: number) {
    if (event.target.value.length === 1 && index < this.inputs.length - 1) {
      const nextInput = document.querySelectorAll('.digit-input')[index] as HTMLInputElement;
      nextInput?.focus();
    }
  }

  moveToPrev(event: any, index: number) {
    if (event.target.value === '' && index > 0) {
      const prevInput = document.querySelectorAll('.digit-input')[index - 1] as HTMLInputElement;
      prevInput?.focus();
    }
  }

  handleInput(index: number) {
    const fields = this.inputFields.toArray();
    if (index < fields.length - 1) {
      fields[index + 1].nativeElement.focus();
    }
  }

  // Método del ciclo de vida para limpiar el Worker al destruir el componente
  ngOnDestroy() {
    clearInterval(this.interval);
    this.terminateWorker()
  }
}
